import Cookies from "js-cookie";
import React from "react";
const Kid = React.lazy(() => import("../pages/kid"));
const LifeStyle = React.lazy(() => import("../pages/lifeStyle"));
const Tourism = React.lazy(() => import("../pages/tourism"));
const OnBoardingPages = React.lazy(() => import("../pages/onBoardingPages"));
const DownloadApp = React.lazy(() => import("../pages/downloadApp"));
const Home = React.lazy(() => import("../pages/home"));
const Commodity = React.lazy(() => import("../pages/commodity/Commodity"));
const Login = React.lazy(() => import("../pages/login/Login"));

const PasswordPage = React.lazy(() => import("../pages/login/PasswordPage"));
const StoreDetails = React.lazy(() => import("../pages/store/StoreDetails"));
const WalletsList = React.lazy(() => import("../pages/wallet/WalletsList"));
const PaymentResault = React.lazy(() =>
  import("../pages/payment/PaymentResault")
);
const BuySubscribtion = React.lazy(() =>
  import("../pages/Loans/BuySubscribtion")
);
const Loan = React.lazy(() => import("../pages/Loans/index"));
const LoanDetail = React.lazy(() =>
  import("../pages/Loans/loanPages/LoanDetail")
);
const Internet = React.lazy(() =>
  import("../pages/services/internet/Interntet")
);
const Charge = React.lazy(() => import("../pages/services/charge/Charge"));
const Live = React.lazy(() => import("../pages/Live"));
const SampleCode = React.lazy(() => import("../pages/SampleCode"));
const GetShebaLanding = React.lazy(() =>
  import("../pages/error/GetShebaLanding")
);
const GetApp = React.lazy(() => import("../pages/getApp/GetApp"));
const Investment = React.lazy(() => import("../pages/investment/Investment"));
const CommodityDetail = React.lazy(() =>
  import("../pages/commodity/CommodityDetail")
);
const HealthServices = React.lazy(() => import("../pages/healthServices"));
const Bills = React.lazy(() => import("../pages/services/bills"));
const AddBills = React.lazy(() => import("../pages/services/bills/addBill"));
const BillInformation = React.lazy(() =>
  import("../pages/services/bills/billInformation")
);

const Payman = React.lazy(() => import("../pages/payman"));

const hasUserUsedTheApp = Cookies.get("hasUserUsedTheApp");
const token = Cookies.get("token");

export const publicRoutes = [
  {
    path: "/",
    element:
      window.innerWidth < 750 && !hasUserUsedTheApp && !token ? (
        <OnBoardingPages />
      ) : (
        <Home />
      ),
  },
  { path: "/get-app", element: <GetApp /> },
  { path: "/commodity", element: <Commodity /> },

  { path: "/login", element: <Login /> },
  { path: "/password", element: <PasswordPage /> },

  { path: "/storedetail", element: <StoreDetails /> },
  { path: "/wallets", element: <WalletsList /> },
  { path: "/confirm/payment/verified", element: <PaymentResault /> },
  { path: "/confirm/payment/cancel", element: <PaymentResault /> },
  { path: "/buysubscribtion", element: <BuySubscribtion /> },
  { path: "/loan", element: <Loan /> },
  { path: "/loan/:name", element: <LoanDetail /> },
  { path: "/internet", element: <Internet /> },
  { path: "/charge", element: <Charge /> },
  { path: "/live", element: <Live /> },
  { path: "/gateway-redirect/:id", element: <SampleCode /> },
  { path: "/money-return/:id", element: <GetShebaLanding /> },
  { path: "/get-app", element: <GetApp /> },
  { path: "/investment", element: <Investment /> },
  { path: "/digitallist", element: <CommodityDetail /> },
  { path: "/health-services", element: <HealthServices /> },
  { path: "/tourism", element: <Tourism /> },
  { path: "/life-style", element: <LifeStyle /> },
  { path: "/kid", element: <Kid /> },
  { path: "/download-app", element: <DownloadApp /> },

  { path: "/bills", element: <Bills /> },
  { path: "/bills/add", element: <AddBills /> },
  { path: "/bills/add/:billType", element: <BillInformation /> },

  { path: "/payman", element: <Payman /> },

  { path: "*", element: <Home /> },
];
